import React from "react";
import { Navigate } from "react-router-dom";

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  // If token and user exist, redirect to dashboard
  if (token && user) {
    return <Navigate to="/index" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
